import { Directive, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appClearOnAltD]'
})
export class ClearOnAltDDirective {
  @Input() clearValue: any = ''; // valor padrão para reset

  constructor(@Optional() private controlDir: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.altKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();

      const control = this.controlDir?.control;
      if (control) {
        control.setValue(this.clearValue);
      }
    }
  }
}
